import { lazy, type ComponentType } from "react";

/**
 * Wraps React.lazy with a single retry + page reload on chunk load failure.
 * This handles the case where a new deployment invalidates old chunk hashes
 * and users with stale tabs get "Failed to fetch dynamically imported module" errors.
 */
export function lazyWithRetry<T extends ComponentType<any>>(
  importFn: () => Promise<{ default: T }>,
) {
  return lazy(() =>
    importFn().catch((error: unknown) => {
      const storageKey = "lazyWithRetry_reloaded";
      const hasReloaded = sessionStorage.getItem(storageKey);

      if (!hasReloaded) {
        sessionStorage.setItem(storageKey, "true");
        window.location.reload();
        return new Promise<{ default: T }>(() => {});
      }
      sessionStorage.removeItem(storageKey);
      throw error;
    }),
  );
}
